import React from 'react'

import { Popup } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'

type RemoveProductConfirmationProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  policyName: string
  productName: string
  isLastMainProduct: boolean
  translate: (key: string, params?: Record<string, string>) => string
}

export const RemoveProductConfirmation: React.FC<RemoveProductConfirmationProps> = ({
  isOpen,
  onClose,
  onConfirm,
  policyName,
  productName,
  isLastMainProduct,
  translate,
}) => {
  const message = isLastMainProduct
    ? translate(
        'You are about to remove "{productName}" from the "{policyName}" policy. This is the last main product, so all related items will also be removed. Do you want to continue?',
        { productName, policyName }
      )
    : translate('Are you sure you want to remove "{productName}" from the "{policyName}" policy?', {
        productName,
        policyName,
      })

  return (
    <Popup ariaLabel={translate('Remove product')} isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col gap-3 text-gray-700">
        <h2 className="m-0 text-xl font-semibold">{translate('Confirm removal')}</h2>
        <p className="m-0 text-base">{message}</p>
        <div className="flex flex-col-reverse justify-between gap-3 sm:flex-row md:justify-end">
          <Button variant="secondary" className="m-0" onClick={onClose}>
            {translate('Cancel')}
          </Button>
          <Button variant="danger" className="m-0" onClick={onConfirm}>
            {translate('Confirm')}
          </Button>
        </div>
      </div>
    </Popup>
  )
}
